import { Box } from '@medly-components/core';
import { Header as StyledHeader } from 'components/layout/Header/Header.styled';
import styled from 'styled-components';
import { zIndex } from '../../../theme/zIndex';

export const Header = styled(StyledHeader)<{ hideShadow: boolean }>`
    height: 6.4rem;
    min-height: 6.4rem;
    display: flex;
    gap: 0;
    padding: 0;
    @media (min-width: ${({ theme }) => theme.breakpoints.M.min}px) {
        height: 7.2rem;
    }
    z-index: ${zIndex.onboardingHeaderZIndex};
    box-shadow: ${({ hideShadow }) => hideShadow && 'none'};
`;

export const HeaderButton = styled(Box)`
    padding: 0;
    align-items: center;
    cursor: pointer;
    svg {
        height: 2.4rem;
        width: 2.4rem;
        cursor: pointer;
    }
    span {
        color: ${({ theme }) => theme.colors.darkBlue};
        font-size: 16px;
    }
    @media (max-width: ${({ theme }) => {
            return theme.breakpoints.S.max;
        }}px) {
        span {
            display: none;
        }
    }
`;

export const RightButton = styled(HeaderButton)`
    margin-right: 9.6rem;
    @media (max-width: ${({ theme }) => {
            return theme.breakpoints.M.max;
        }}px) {
        margin-right: 2.4rem;
    }
    span {
        margin-left: 0.4rem;
    }
`;

export const LeftButton = styled(HeaderButton)`
    margin-left: 9.6rem;
    @media (max-width: ${({ theme }) => {
            return theme.breakpoints.M.max;
        }}px) {
        margin-left: 2.4rem;
    }
    span {
        margin-left: 0.4rem;
    }
`;

export const ProgressBar = styled('div')<{ progress: number }>`
    display: flex;
    height: 1.2rem;
    background-color: ${({ theme }) => theme.colors.royalBlue[100]};

    &::after {
        content: '';
        width: ${({ progress }) => progress}%;
        background-color: ${({ theme }) => theme.colors.royalBlue[500]};
    }
`;
